const MS_IN_MINUTES = 60 * 1000;

const formatTime = (date: Date) => date.toISOString()?.replace(/-|:|\.\d+/g, '');

interface Event {
  start: Date;
  end?: Date;
  description?: string;
  location: string;
  title: string;
  duration: number;
}

const calculateEndTime = (event: Event) => {
  return event.end
    ? formatTime(event.end)
    : formatTime(new Date(event.start.getTime() + event.duration * MS_IN_MINUTES));
};

const calendarGenerators = {
  apple: function (event: Event) {
    return this.ics(event);
  },

  google: function (event: Event) {
    const startTime = formatTime(event.start);
    const endTime = calculateEndTime(event);

    const href = encodeURI(
      [
        'https://www.google.com/calendar/render',
        '?action=TEMPLATE',
        '&text=' + (event.title || ''),
        '&dates=' + (startTime || ''),
        '/' + (endTime || ''),
        '&details=' + (event.description || ''),
        '&location=' + (event.location || ''),
        '&sprop=&sprop=name:',
      ].join(''),
    );
    return href;
  },

  ics: function (event: Event) {
    const startTime = formatTime(event.start);
    const endTime = calculateEndTime(event);

    const href = encodeURI(
      'data:text/calendar;charset=utf8,' +
        [
          'BEGIN:VCALENDAR',
          'VERSION:2.0',
          'BEGIN:VEVENT',
          'URL:' + document.URL,
          'DTSTART:' + (startTime || ''),
          'DTEND:' + (endTime || ''),
          'SUMMARY:' + (event.title || ''),
          'DESCRIPTION:' + (event.description || ''),
          'LOCATION:' + (event.location || ''),
          'END:VEVENT',
          'END:VCALENDAR',
        ].join('\n'),
    );

    return href;
  },

  outlook: function (event: Event) {
    return this.ics(event);
  },

  yahoo: function (event: Event) {
    const eventDuration = event.end ? (event.end.getTime() - event.start.getTime()) / MS_IN_MINUTES : event.duration;
    const yahooHourDuration =
      eventDuration < 600 ? '0' + Math.floor(eventDuration / 60) : Math.floor(eventDuration / 60) + '';
    const yahooMinuteDuration = eventDuration % 60 < 10 ? '0' + (eventDuration % 60) : (eventDuration % 60) + '';
    const yahooEventDuration = yahooHourDuration + yahooMinuteDuration;
    const st = formatTime(new Date(event.start.getTime() - event.start.getTimezoneOffset() * MS_IN_MINUTES)) || '';

    const href = encodeURI(
      [
        'http://calendar.yahoo.com/?v=60&view=d&type=20',
        '&title=' + (event.title || ''),
        '&st=' + st,
        '&dur=' + (yahooEventDuration || ''),
        '&desc=' + (event.description || ''),
        '&in_loc=' + (event.location || ''),
      ].join(''),
    );

    return href;
  },
};

export const generateCalendar = function (event: Event) {
  return {
    apple: calendarGenerators.apple(event),
    google: calendarGenerators.google(event),
    outlook: calendarGenerators.outlook(event),
    yahoo: calendarGenerators.yahoo(event),
  };
};
